<template>
  <main-layout>
    <new-site-dialog
      @close="isNewSiteDialogOpened = false"
      @created="newSiteCreated"
      :client-id="company.id"
      :default-name="searchString"
      v-if="isNewSiteDialogOpened"
    />
    <site-dialog
      v-model="isSiteDialogOpened"
      @close="isSiteDialogOpened = false"
      @save="siteUpdated"
      catch-save
      :client="company"
      :site="selectedSite"
      v-if="isSiteDialogOpened"
    />
    <div>
      <v-row no-gutters align="center" class="content-header">
        <span class="font-weight-bold">Sites</span>
        <v-spacer />
        <v-btn :disabled="!$canWrite" dark color="primary" elevation="0" @click="$canWrite && (isNewSiteDialogOpened = true)">
          <v-icon left>add</v-icon>
          Nouveau site
        </v-btn>
      </v-row>
      <div class="page-main-content">
        <template>
          <v-row no-gutters justify="center" align="center">
            <div>
              <v-row no-gutters justify="center" align="center" class="border-component mr-3" style="height: 54px;">
                <v-autocomplete
                  :items="tags"
                  v-model="searchTags"
                  single-line
                  solo
                  label="Tous les tags"
                  hide-details
                  item-text="label"
                  item-value="id"
                  no-data-text="Aucun tag"
                  clearable
                  dense
                  flat
                  multiple
                  chips
                  deletable-chips
                  small-chips
                  style="width: 100%;"
                  class="n-multi-select input-no-b-line"
                >
                  <template v-slot:item="{ item: tag }">
                    <v-list-item-avatar size="20" style="margin-top: 4px;">
                      <v-avatar :color="tag.color"></v-avatar>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      {{ tag.label }}
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-row>
            </div>
            <v-col class="py-2 px-3 search-bar border-component">
              <v-text-field
                v-model="searchString"
                placeholder="Rechercher un site..."
                prepend-icon="search"
                hide-details
                dense
                clearable
                class="input-no-b-line"
              ></v-text-field>
            </v-col>
          </v-row>
          <div class="pt-4 pb-1 pr-1" v-if="!isFetchingSites">
            <v-row no-gutters justify="center" align="center">
              <h3 class="pl-2">{{ filteredSites.length }} {{ `site` | pluralize(filteredSites.length) }} {{ `trouvé` | pluralize(filteredSites.length) }}</h3>
              <v-spacer />
              <div v-if="hasPagination">
                <v-row no-gutters justify="center" align="center">
                  <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text" @click="previousPage">
                    <v-icon>chevron_left</v-icon>
                  </v-btn>
                  <div class="ml-2 primary--text font-weight-bold">
                    {{ currentPage + 1 }} / {{ nbPages }}
                  </div>
                  <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text ml-2" @click="nextPage">
                    <v-icon>chevron_right</v-icon>
                  </v-btn>
                </v-row>
              </div>
            </v-row>
          </div>
          <n-card depressed class="mt-4" style="min-height: 6px;">
            <v-progress-linear
              color="primary"
              indeterminate
              rounded
              height="6"
              class="absolute-progress"
              v-if="isFetchingSites"
            />
            <v-list two-line class="pa-0">
              <v-row no-gutters justify="center" align="center" class="pa-6" v-if="!filteredSitesPaginated.length && !isFetchingSites">
                Aucun résultat
              </v-row>
              <template v-for="(site, index) in filteredSitesPaginated">
                <v-list-item
                  :key="`site-${index}`"
                  @click="openSite(site)"
                >
                  <v-list-item-avatar>
                    <v-icon>place</v-icon>
                  </v-list-item-avatar>

                  <v-row no-gutters>
                    <v-col align="left">
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-row no-gutters justify="center" align="center">
                            {{ site.name }}
                            <v-spacer />
                            <div class="font-italic pl-2" v-if="site.$tenant.length">
                              {{ site.$tenant }}
                              <v-icon small class="ml-1">person</v-icon>
                            </div>
                            <div class="font-italic pl-2" v-if="site.$owner.length">
                              {{ site.$owner }}
                              <v-icon small class="ml-1">badge</v-icon>
                            </div>
                          </v-row>
                        </v-list-item-title>
                        <v-list-item-subtitle v-if="site.$fullAddress.length || site.$phone1.length">
                          <v-row no-gutters>
                            <v-col align="left">
                              {{ site.$fullAddress }}
                            </v-col>
                            <v-col align="right">
                              <v-icon small class="pb-1" v-if="site.$phone1.length">phone</v-icon>
                              {{ site.$phone1 }}
                            </v-col>
                          </v-row>
                        </v-list-item-subtitle>
                        <v-list-item-content class="pb-0 pt-1" v-if="site.clientTags.length">
                          <div>
                            <tag-chip v-for="tag in site.clientTags" :key="`tag-${tag.id}`" :tag="tag" />
                          </div>
                        </v-list-item-content>
                      </v-list-item-content>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-divider
                  v-if="index + 1 < sites.length"
                  :key="index"
                ></v-divider>
              </template>
            </v-list>
          </n-card>
          <div class="pa-4" v-if="hasPagination">
            <v-row no-gutters justify="center" align="center">
              <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text" @click="previousPage">
                <v-icon>chevron_left</v-icon>
              </v-btn>
              <div class="ml-2 primary--text font-weight-bold">
                {{ currentPage + 1 }} / {{ nbPages }}
              </div>
              <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text ml-2" @click="nextPage">
                <v-icon>chevron_right</v-icon>
              </v-btn>
            </v-row>
          </div>
        </template>
      </div>
    </div>
  </main-layout>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapMutations, mapState } from 'vuex';
import MainLayout from '@/views/settings/MainLayout.vue';
import NewSiteDialog from '@/components/NewSiteModal.vue';
import SiteDialog from '@/components/SiteDialog.vue';

const PAGE_SIZE = 25;

export default {
  name: `SettingsStatuses`,
  data: () => ({
    isFetchingSites: false,
    isNewSiteDialogOpened: false,
    isSiteDialogOpened: false,
    selectedSite: {},
    searchTags: [],
    searchString: ``,
    currentPage: 0,
  }),
  computed: {
    ...mapState(`model/client`, [
      `company`,
      `isRealEstate`,
    ]),
    ...mapState(`model/status`, [
      `statuses`,
    ]),
    ...mapState(`ui/settingsSites`, [
      `sites`,
      `tags`,
    ]),
    flavoredSites() {
      return _.chain(this.sites)
        .map(site => {
          const address = _.trim(site.address);
          const postalCodeAndCity = _.trim(`${site.postalCode} ${site.city}`);
          const hasAddressAndPostalCodeOrCity = address.length && postalCodeAndCity.length;
          return {
            ...site,
            clientTags: _.sortBy(site.clientTags || [], tag => _.toLower(tag.label)),
            makerTags: _.sortBy(site.makerTags || [], tag => _.toLower(tag.label)),
            $fullAddress: _.trim(`${address} ${hasAddressAndPostalCodeOrCity ? `-` : ``} ${postalCodeAndCity}`),
            $phone1: _.trim(site.phone1 || ``),
            $searchString: _.toLower(`${site.name} ${address} ${postalCodeAndCity} ${site.tenant} ${site.owner} ${site.Zelok_id || ``}`.replace(/ {2}/g, ` `)),
            $clientTagsIds: _.map(site.clientTags || [], `id`),
            $tenant: this.isRealEstate ? _.trim(site.tenant) || `` : ``,
            $owner: this.isRealEstate ? _.trim(site.owner) || `` : ``,
          };
        })
        .sortBy(`$searchString`)
        .value();
    },
    filteredSites() {
      let sites = this.flavoredSites;
      if (this.searchString) {
        this.searchString.split(` `).forEach(searchStringPart => {
          searchStringPart = _.toLower(searchStringPart);
          sites = _.filter(sites, site =>
            site.$searchString.indexOf(searchStringPart) !== -1
          );
        });
      }
      if (this.searchTags.length) {
        sites = _.filter(sites, site =>
          _.without(this.searchTags, ...site.$clientTagsIds).length === 0
        );
      }
      return sites;
    },
    filteredSitesPaginated() {
      const firstIndex = this.currentPage * PAGE_SIZE;
      return this.filteredSites.slice(firstIndex, firstIndex + PAGE_SIZE);
    },
    hasPagination() {
      return this.filteredSites.length > PAGE_SIZE;
    },
    nbPages() {
      return Math.ceil(this.filteredSites.length / PAGE_SIZE);
    },
  },
  methods: {
    ...mapMutations(`ui/settingsSites`, [
      `SET_SITES`,
    ]),
    ...mapActions(`ui/settingsSites`, [
      `setCurrentClient`,
      `fetchList`,
      `fetchTags`,
    ]),
    emptySites() {
      this.SET_SITES([]);
    },
    async fetchSites() {
      this.isFetchingSites = true;
      await this.fetchList();
      this.isFetchingSites = false;
    },
    previousPage() {
      if (this.currentPage > 0) {
        this.currentPage -= 1;
      }
    },
    nextPage() {
      const newPageSiteIndex = (this.currentPage + 1) * PAGE_SIZE;
      if (newPageSiteIndex < this.filteredSites.length) {
        this.currentPage += 1;
      }
    },
    newSiteCreated() {
      this.isNewSiteDialogOpened = false;
      this.fetchSites();
    },
    async siteUpdated(site) {
      this.isFetchingSites = true;
      this.isSiteDialogOpened = false;
      this.emptySites();
      await this.$store.dispatch(`model/site/saveSite`, site);
      this.fetchSites();
    },
    openSite(site) {
      this.selectedSite = site;
      this.isSiteDialogOpened = true;
    },
  },
  beforeMount() {
    this.currentPage = 0;
    this.setCurrentClient(this.company);
    this.emptySites();
    this.fetchTags();
    this.fetchSites();
  },
  watch: {
    searchString() {
      this.currentPage = 0;
    },
    searchTags() {
      this.currentPage = 0;
    },
  },
  components: {
    MainLayout,
    NewSiteDialog,
    SiteDialog,
  },
};
</script>

<style lang="scss">
  .sheet-item {
    border: 2px solid rgba(119, 119, 119, 0.527) !important;
    border-radius: 4px;
  }
</style>
